









import { defineComponent } from "@vue/composition-api";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { ProcessingStatus } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import AudioPlayer from "@/components/AudioPlayer";

export default defineComponent({
  name: "MessageItemAttachmentAudio",
  components: { AudioPlayer },
  props: {
    attachment: { type: Object as () => FileData, required: true },
    isAuthor: { type: Boolean, required: true },
    available: { type: Boolean, required: true },
    processingStatus: { type: String as () => ProcessingStatus, required: true },
  },
  data() {
    return {
      clicked: false,
    };
  },
  computed: {
    isAvailable(): boolean {
      if (!this.isAuthor) return this.available;
      if (!this.available) return this.clicked;
      return this.available;
    },
  },
  methods: {
    onUnlock() {
      this.clicked = true;
      if (!this.isAvailable) {
        this.$emit("unlock");
      }
    },
  },
});
